import axios from 'axios';
 
// export const request_jwt_from_basicauth = async (username, password) => { 
//     if (username == 'tootles' && password == 'smellmyfarts69') {
//         const result_data = { jwt: 'sdfgsdfgfdgsd.mocktokenclaims.sfsdfgsdfg' }
//         return { data: result_data, status: 200 }
//     }
//     return { data: { jwt: null },  status: 400 }
// }

export const validate_account_credentials = async (username, password) => {
    const result_data = {
        acct_id: username,
        secret: password,
    }
    if (!username || !password) {
        result_data.authentication_code = 'fail'
        result_data.authorization_code = 'fail'
    } else if (username == 'tootles' && password == 'smellmyfarts69') {
        result_data.authentication_code = 'pass'
        result_data.authorization_code = 'pass'
    }
    return result_data
}
